.initialSearchView {
  padding: 0 24px;
  max-height: 560px;
  overflow: auto;
  scrollbar-color: #28272a var(--primitives-colors-neutral-980);
  clip-path: inset(0 round 14px);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    visibility: hidden;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: rgb(255, 255, 255, 0.2);
  }

  &::-webkit-scrollbar:window-inactive {
    visibility: hidden;
  }

  .phone &,
  .tablet & {
    max-height: calc(100% - 104px);
    padding: 0 16px;
    clip-path: none;
  }

  .searchResults,
  .searchHistoryResults {
    margin-top: 16px;
    margin-bottom: 24px;
  }

  &.hasHistory {
    padding-bottom: 24px;

    // &::after {
    //   content: "";
    //   display: block;
    //   width: 100%;
    //   height: 56px;
    //   position: absolute;
    //   background: linear-gradient(180deg, rgba(16, 16, 16, 0) 0%, rgba(16, 16, 16, 0.67) 49.57%);
    //   border-bottom-right-radius: 24px;
    //   border-bottom-left-radius: 24px;
    //   bottom: 1px;
    //   left: 0;
    // }
  }
}